// extracted by mini-css-extract-plugin
export default {"card":"DashboardCard_card__JzYvL"};